import { useEffect, useState } from 'react'
import { defaultVars, findVariablesInObject } from 'utils/variables'
import PropTypes from 'prop-types'
import { Menu, MenuItem, Dialog, ListItem, List, Typography, DialogContent, Container, CardContent, Grid } from '@material-ui/core'
import CardTitle from 'components/card/title'
import TaskComponent from 'components/task/createTask/taskFormComponent'
import { isUserInputType } from 'utils/rules'
import { useClient } from 'components/session/clientSession'
import { useRouter } from 'next/router'
import { useSession } from 'components/session/session'
import { tasksInTemplate } from 'utils/templates'

export default function VariableMenu({ showVariableMenu, setShowVariableMenu, setContent, task, anchorEl }) {

  const session = useSession()
  const clientSession = useClient()
  const [showDialog, setShowDialog] = useState(false)
  const [dialogContent, setDialogContent] = useState(null)
  const [customVars, setCustomVars] = useState([])
  const router = useRouter()
  const { templateid } = router.query

  useEffect(() => {
    findVariablesInObject(task).then(vars => setCustomVars(vars.filter(e => !defaultVars.includes(e))))
  }, [task])

  const replaceAndSave = val => {
    setContent(val)
    setShowDialog(false)
  }

  const createList = vars => {
    setShowVariableMenu(false)
    setShowDialog(true)
    setDialogContent(<List>{Object.values(vars).map(v => <ListItem key={v} button onClick={() => replaceAndSave(v)}>{v}</ListItem>)}</List>)
  }

  const showTaskVariables = (selectedTask, taskid) => {
    setDialogContent(<ComponentChooser components={Object.values(selectedTask?.Components || {})} action={index => {
      const id = selectedTask.Components[index].ComponentID ?? (index + 1)
      let key = 'Value'
      if (!isUserInputType(selectedTask.Components[index])) {
        switch (selectedTask.Components[index].Type) {
          case 'image':
            key = 'Prompt'
            break
          case 'textBlock':
            key = 'HTML'
            break
          case 'link':
          case 'iFrame':
            key = 'URL'
            break
          default:
            key = 'Prompt'
        }
      }
      if (taskid) replaceAndSave(`@Template.${taskid}.${id}.${key}`)
      else replaceAndSave(`@Task.${id}.${key}`)
    }} />)
    setShowVariableMenu(false)
    setShowDialog(true)
  }

  const getTasksInTemplate = async () => {
    const tasks = await tasksInTemplate(session, clientSession, templateid)
    setShowVariableMenu(false)
    setShowDialog(true)
    setDialogContent(<List>{Object.values(tasks).map(task => <ListItem key={task.id} button onClick={() => showTaskVariables(task.data, task.id)}>{task.data.Name}</ListItem>)}</List>)
  }

  return <>
    <Menu open={showVariableMenu} onClose={() => setShowVariableMenu(false)} anchorEl={anchorEl}>
      <MenuItem onClick={() => createList(defaultVars)}>Default Variables</MenuItem>
      {customVars.length > 0 && <MenuItem onClick={() => createList(customVars)}>Custom Variables</MenuItem>}
      {Object.values(task?.Components || {}).length > 0 && <MenuItem onClick={() => showTaskVariables(task)}>Task Variables</MenuItem>}
      {(clientSession?.client?.Metadata?.Sections || templateid) && <MenuItem onClick={getTasksInTemplate}>Template Variables</MenuItem>}
    </Menu>
    <Dialog fullWidth maxWidth='md' open={showDialog} onClose={() => setShowDialog(false)}>
      <DialogContent>
        <Typography variant='h6'>Insert Variable</Typography>
        {dialogContent}
      </DialogContent>
    </Dialog>
  </>
}

VariableMenu.propTypes = {
  showVariableMenu: PropTypes.bool.isRequired,
  setShowVariableMenu: PropTypes.func.isRequired,
  setContent: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
  anchorEl: PropTypes.object
}

function ComponentChooser({ components, action }) {
  return <Container>
    <CardContent>
      <CardTitle
        title='Choose Component'
        subtitle='The value of this component will be inserted into this variable.' />
      <Grid container spacing={1}>
        {components.map((c, componentIndex) => {
          if (c.TaskType === 'lineBreak') return null
          return <Grid key={componentIndex} item xs={12}>
            <TaskComponent task={{}} taskid={''} component={c} componentIndex={componentIndex} save={() => { }} saveFast={() => { }} selected={-1} setSelected={action} filepath='' noHoverIcons />
          </Grid>
        }).filter(e => e)}
      </Grid>
    </CardContent>
  </Container>
}

ComponentChooser.propTypes = {
  components: PropTypes.array.isRequired,
  action: PropTypes.func.isRequired
}